<template>
    <TextureStyleForm :texture_style="texture_style" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import TextureStyleForm from './TextureStyleForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    TextureStyleForm
  },
  data() {
    return {
      loaded:false,
      texture_style:null
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.texture_style=await APIRequest.detail('texture-styles',this.$route.params.id)
    this.loaded=true
  }
}
</script>
